export const byPassProps = {
  "mindbodygreen-com_incontent_IAI_article": {
    adUnitPath: "/15184186,1339196/7303_mindbodygreen-com_incontent_IAI_article",
    slotSize: [
      [468, 60],
      [728, 90],
      [300, 250],
      [728, 250],
      [336, 280],
      [300, 50],
      [320, 50],
      [300, 100],
      [320, 100],
    ],
    sizeMapping: [
      {
        viewport: [768, 0],
        slot: [
          [468, 60],
          [728, 90],
          [300, 250],
          [728, 250],
          [336, 280],
        ],
      },
      {
        viewport: [0, 0],
        slot: [
          [300, 50],
          [320, 50],
          [300, 100],
          [320, 100],
          [300, 250],
          [336, 280],
        ],
      },
    ],
  },

  "mindbodygreen-com_siderail_right_article": {
    adUnitPath: "15184186,1339196/7303_mindbodygreen-com_siderail_right_article",
    slotSize: [
      [300, 250],
      [336, 280],
      [120, 600],
      [160, 600],
      [300, 600],
    ],
    sizeMapping: [
      {
        viewport: [1200, 0],
        slot: [
          [300, 250],
          [336, 280],
          [120, 600],
          [160, 600],
          [300, 600],
        ],
      },
      { viewport: [0, 0], slot: [] },
    ],
  },

  "mindbodygreen-com_incontent_reusable_970": {
    adUnitPath: "/15184186,1339196/7303_mindbodygreen-com_incontent_reusable_970",
    slotSize: [
      [468, 60],
      [728, 90],
      [970, 90],
      [300, 250],
      [728, 250],
      [970, 250],
      [336, 280],
      [300, 50],
      [320, 50],
      [300, 100],
      [320, 100],
    ],
    sizeMapping: [
      {
        viewport: [1000, 0],
        slot: [
          [468, 60],
          [728, 90],
          [970, 90],
          [300, 250],
          [728, 250],
          [970, 250],
          [336, 280],
        ],
      },
      {
        viewport: [768, 0],
        slot: [
          [468, 60],
          [728, 90],
          [300, 250],
          [728, 250],
          [336, 280],
        ],
      },
      {
        viewport: [0, 0],
        slot: [
          [300, 50],
          [320, 50],
          [300, 100],
          [320, 100],
          [300, 250],
          [336, 280],
        ],
      },
    ],
  },

  "mindbodygreen-com_leaderboard_article_breaker": {
    adUnitPath: "/15184186,1339196/7303_mindbodygreen-com_leaderboard_article_breaker",
    slotSize: [
      [468, 60],
      [728, 90],
      [970, 90],
      [728, 250],
      [970, 250],
      [300, 50],
      [320, 50],
      [300, 100],
      [320, 100],
      [300, 250],
      [336, 280],
    ],
    sizeMapping: [
      {
        viewport: [1000, 0],
        slot: [
          [468, 60],
          [728, 90],
          [970, 90],
          [728, 250],
          [970, 250],
        ],
      },
      {
        viewport: [768, 0],
        slot: [
          [468, 60],
          [728, 90],
          [728, 250],
        ],
      },
      {
        viewport: [0, 0],
        slot: [
          [300, 50],
          [320, 50],
          [300, 100],
          [320, 100],
          [300, 250],
          [336, 280],
        ],
      },
    ],
  },

  "mindbodygreen-com_ATF_leaderboard": {
    adUnitPath: "15184186,1339196/7303_mindbodygreen-com_ATF_leaderboard",
    slotSize: [
      [468, 60],
      [728, 90],
      [970, 90],
      [728, 250],
      [970, 250],
      [300, 50],
      [320, 50],
      [300, 100],
      [320, 100],
    ],
    sizeMapping: [
      {
        viewport: [1000, 0],
        slot: [
          [468, 60],
          [728, 90],
          [970, 90],
          [728, 250],
          [970, 250],
        ],
      },
      {
        viewport: [768, 0],
        slot: [
          [468, 60],
          [728, 90],
          [728, 250],
        ],
      },
      {
        viewport: [0, 0],
        slot: [
          [300, 50],
          [320, 50],
          [300, 100],
          [320, 100],
        ],
      },
    ],
  },
}
